module.exports = __webpack_public_path__ + "img/10mmzuantoujia.prt.aa6bb3b6.jpg";